import Flickity from 'flickity';

const carousel = document.querySelector('.js-who-carousel');
const selector = document.querySelector('.js-who-carousel-selector');

const indexes = {
    en_US: 0,
    en_GB: 1,
    en_PL: 1,
    en_AU: 13,
    de_DE: 1,
    es_ES: 1,
    es_MX: 10,
    es_AR: 9,
    fr_FR: 1,
    it_IT: 1,
    ja_JP: 12,
    pl_PL: 1,
    ro_RO: 1,
    el_GR: 1,
    hu_HU: 1,
    cs_CZ: 1,
    pt_BR: 5,
    tr_TR: 4,
    ru_RU: 11,
    ko_KR: 3,
}

const initialIndex = indexes[window.locale] || 0;
console.log(initialIndex, window.locale, indexes)
const flkty = new Flickity(carousel, {
    initialIndex,
    lazyLoad: true,
    pageDots: false,
    wrapAround: true,
    draggable: false,
    adaptiveHeight: true,
    arrowShape: {
        x0: 20,
        x1: 70, y1: 50,
        x2: 75, y2: 45,
        x3: 30
    }
});

selector.addEventListener('change', (event) => {
    flkty.select(event.target.selectedIndex, false, true)
});
